// @flow

import * as React from "react";

import InlineTextLink from "../../components/InlineTextLink/InlineTextLink";

import type { TaskType } from "../../data/tasks";

import "./task.css";

const task = {
  prompt:
    "What is the probability that you'd be happy to have read this paper (in %)?",
  confidenceLabels: {
    left: "Definitely unhappy",
    middle: "No idea",
    right: "Definitely happy"
  },
  answerText: {
    false: "You'd be unhappy",
    true: "You'd be happy"
  },
  renderQuestion(task: TaskType): React.Node {
    const data = task.metadata;
    return (
      <div className="Papers-Container">
        <p className="Papers-Container-Title">{data.title}</p>
        <p>{data.abstract}</p>
        <ul>
          {data.reviews.map((review, i) => (
            <li key={i}>
              <InlineTextLink title={`Review ${i}`}>
                {review.text}
              </InlineTextLink>
            </li>
          ))}
        </ul>
      </div>
    );
  },
  tools: {
    pdf: true
  }
};

export default task;



// WEBPACK FOOTER //
// ./src/templates/papers/task.js